import { FiUser } from 'react-icons/fi';

export default function UserSelection({ name }) {
  return (
    <div className="selected-guest-wrapper">
      <div className="selected-guest-container">
        <div className="selected-user-icon">
          <FiUser />
        </div>
        <div className="selected-user-name">{name} </div>
      </div>
    </div>
  );
}
